<template>
  <div>
      <div class="table-head">
          <h4>{{$t('vdog_winner_placement_betting')}}</h4>
      </div>
      <div class="table-body">
        <vdog-winner-placement-single-row v-for="index in 6" :key="index"
          class="single-main-result"
          :match="match"
          :awardPlace="1"
          :place="index" />
      </div>
  </div>
</template>

<script>
import VDogWinnerAndPlacementBettingSingleRow from '@/components/grayhound/results/VDogWinnerAndPlacementBettingSingleRow.vue'

export default {
  components: {
    'vdog-winner-placement-single-row': VDogWinnerAndPlacementBettingSingleRow
  },
  props: {
    match: {
      type: Object,
      required: true
    }
  }
}
</script>
